<template>
  <b-container>
    <Breadcrumbs crumbString="View Our Work,Jordan River Trail"></Breadcrumbs>
    <b-row>
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <p>Wayfinding and Regulation Signs<br>
          Salt Lake City, Utah<br>
          ImageLoc signs with powder coated bases</p>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8 image-slider-container">
        <ImageSlider :images="images" class="image-slider"></ImageSlider>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'
  import ImageSlider from '@/components/ImageSlider.vue'

  export default {
    components: {
      Breadcrumbs,
      ImageSlider
    },
    props: {
      images: {
        default: () => [
          require('@/assets/images/pages/jordan-river/jordan-river-wayfinding-signs01.jpg'),
          require('@/assets/images/pages/jordan-river/jordan-river-wayfinding-signs02.jpg'),
          require('@/assets/images/pages/jordan-river/jordan-river-wayfinding-signs03.jpg'),
          require('@/assets/images/pages/jordan-river/jordan-river-wayfinding-signs04.jpg'),
          require('@/assets/images/pages/jordan-river/jordan-river-wayfinding-signs05.jpg'),
          require('@/assets/images/pages/jordan-river/jordan-river-wayfinding-signs06.jpg'),
          require('@/assets/images/pages/jordan-river/jordan-river-wayfinding-signs07.jpg'),
          require('@/assets/images/pages/jordan-river/jordan-river-wayfinding-signs08.jpg'),
          require('@/assets/images/pages/jordan-river/jordan-river-wayfinding-signs09.jpg'),
          require('@/assets/images/pages/jordan-river/jordan-river-wayfinding-signs10.jpg')
        ],
        type: Array
      }
    },

    data () {
      return {
        title: 'Jordan River Trail'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/viewOurWork/JordanRiver.vue